import script from "./JobTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./JobTasks.vue?vue&type=script&setup=true&lang=js"

import "./JobTasks.vue?vue&type=style&index=0&id=4cf54984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf54984"]])

export default __exports__